import React from 'react';
import * as Icons from 'lucide-react';
import { companyInfo, teamMembers } from '../mockData';

const About = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1496247749665-49cf5b1022e9"
            alt="About Profab"
            className="w-full h-full object-cover" />

          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 to-gray-900/60" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            About Profab
          </h1>
          <p className="text-xl text-gray-200 max-w-2xl mx-auto">Crafting excellence in metal fabrication since 2007

          </p>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">We are a successful company, well established in Bangalore since 2007, in the business of top quality Aluminium Composite Panel Cladding, Structural Glazing and Aluminium Windows. Our vision to consistently provide comprehensive solutions, synthesized with high Quality-control standards, attention to detail and timely deliveries, with the assistance & diligence due to our very dedicated team, has garnered for us tremendous support & accolades from all our esteemed clientele.









              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed"></p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Today, Profab stands as a trusted partner for businesses seeking reliable, high-quality 
                metal fabrication services. Our state-of-the-art facility and experienced team enable 
                us to tackle the most challenging projects with confidence and precision.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/185039/pexels-photo-185039.jpeg"
                alt="Profab facility"
                className="rounded-lg shadow-2xl" />

            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="bg-white rounded-lg p-10 shadow-md">
              <div className="w-16 h-16 bg-profab-blue/10 rounded-lg flex items-center justify-center mb-6">
                <Icons.Target className="text-profab-blue" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              <p className="text-gray-600 leading-relaxed">
                {companyInfo.mission}
              </p>
            </div>
            <div className="bg-white rounded-lg p-10 shadow-md">
              <div className="w-16 h-16 bg-profab-blue/10 rounded-lg flex items-center justify-center mb-6">
                <Icons.Eye className="text-profab-blue" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
              <p className="text-gray-600 leading-relaxed">
                {companyInfo.vision}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Values</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              The principles that guide everything we do
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {companyInfo.values.map((value, index) => {
              const IconComponent = Icons[value.icon] || Icons.Award;
              return (
                <div
                  key={index}
                  className="text-center group">

                  <div className="w-20 h-20 bg-profab-blue/10 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-profab-blue transition-colors">
                    <IconComponent className="text-profab-blue group-hover:text-white transition-colors" size={36} />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>);

            })}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-profab-blue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">Our Track Record</h2>
            <p className="text-xl text-blue-100">
              Numbers that speak to our experience and reliability
            </p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {companyInfo.stats.map((stat, index) =>
            <div key={index} className="text-center">
                <div className="text-5xl md:text-6xl font-bold text-white mb-2">
                  {stat.value}
                </div>
                <div className="text-blue-100 font-medium text-lg">{stat.label}</div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Choose Profab</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              What sets us apart in the metal fabrication industry
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-profab-blue/10 rounded-lg flex items-center justify-center">
                  <Icons.CheckCircle className="text-profab-blue" size={24} />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Advanced Technology
                </h3>
                <p className="text-gray-600">
                  State-of-the-art equipment and cutting-edge fabrication techniques ensure 
                  precision and efficiency on every project.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-profab-blue/10 rounded-lg flex items-center justify-center">
                  <Icons.CheckCircle className="text-profab-blue" size={24} />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Experienced Team
                </h3>
                <p className="text-gray-600">
                  Our skilled fabricators and engineers bring decades of combined experience 
                  to every project.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-profab-blue/10 rounded-lg flex items-center justify-center">
                  <Icons.CheckCircle className="text-profab-blue" size={24} />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Quality Assurance
                </h3>
                <p className="text-gray-600">
                  Rigorous quality control processes at every stage ensure superior results 
                  that meet or exceed specifications.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-profab-blue/10 rounded-lg flex items-center justify-center">
                  <Icons.CheckCircle className="text-profab-blue" size={24} />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  On-Time Delivery
                </h3>
                <p className="text-gray-600">
                  We understand the importance of deadlines and consistently deliver projects 
                  on schedule without compromising quality.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-profab-blue/10 rounded-lg flex items-center justify-center">
                  <Icons.CheckCircle className="text-profab-blue" size={24} />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Competitive Pricing
                </h3>
                <p className="text-gray-600">
                  Fair, transparent pricing with no hidden costs. We provide detailed quotes 
                  and work within your budget.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-profab-blue/10 rounded-lg flex items-center justify-center">
                  <Icons.CheckCircle className="text-profab-blue" size={24} />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  Customer Support
                </h3>
                <p className="text-gray-600">
                  Dedicated support throughout your project and beyond. We're here to answer 
                  questions and provide assistance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>);

};

export default About;